export enum PaymentStatus {
  INITIAL = 'INITIAL',
  WAITING_FOR_PAYMENT = 'Waiting for payment',
  COMPLETED = 'Completed',
  EXPIRED = 'Expired',
  INSUFFICIENT_FUNDS = 'Insufficient funds',
  CANCELED = 'Canceled',
  MINTING = 'Minting',
}

export enum PaymentType {
  debit = 'card',
  crypto = 'crypto',
}

export interface IPayment {
  packageName: string;
  requestId: number;
  chainId: number;
  wallet: string;
  symbol: string;
  network: string;
  amountToPay: string;
  createdAt: number;
  expiresAt: number;
  paymentType: PaymentType;
}

export interface PendingPaymentPayload extends Omit<IPayment, 'createdAt' | 'network' | 'chainId'> {
  currencyAddress: string;
}

export interface InsufficientPaymentPayload extends PendingPaymentPayload {
  initialPackagePrice?: string;
  currentBalance: string;
}

export type CompletePaymentPayload = {
  txHash: string;
  networkName: string;
  currencyAddress: string;
  packageName: string;
  paymentType: PaymentType;
};

export type ExpiredPaymentPayload = {
  depositedBalance: string;
} & PendingPaymentPayload;

export type CancelPaymentPayload = {
  currencyAddress: string;
  networkName: string;
  packageName: string;
  paymentType: PaymentType;
};

export type PaymentPendingState = { status: PaymentStatus.WAITING_FOR_PAYMENT; payload: PendingPaymentPayload };
export type PaymentInitialState = { status: PaymentStatus.INITIAL; payload: null };
export type PaymentCompleteState = { status: PaymentStatus.COMPLETED; payload: CompletePaymentPayload };
export type PaymentExpiredState = { status: PaymentStatus.EXPIRED; payload: ExpiredPaymentPayload };
export type PaymentInsufficientState = {
  status: PaymentStatus.INSUFFICIENT_FUNDS;
  payload: InsufficientPaymentPayload;
};
export type PaymentCanceledState = { status: PaymentStatus.CANCELED; payload: CancelPaymentPayload };
export type PaymentMintingState = { status: PaymentStatus.MINTING; payload: PendingPaymentPayload };

export type PaymentStatusState =
  | PaymentInitialState
  | PaymentPendingState
  | PaymentCompleteState
  | PaymentExpiredState
  | PaymentInsufficientState
  | PaymentMintingState
  | PaymentCanceledState;

export type IPaymentToken = {
  name: string;
  symbol: string;
  image: string | null;
  decimals: number;
  address: string;
  isStable: boolean;
};

export type IPaymentNetwork = {
  name: string;
  image: string | null;
  shortName: string;
  tokens: IPaymentToken[];
};

export type PaymentHdWallet = {
  network: string;
  address: string;
  referralCode: string;
};
